'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numberToBytes32 = numberToBytes32;
exports.bytes32ToNumber = bytes32ToNumber;
exports.stringToBytes32 = stringToBytes32;

var _ethers = require('ethers');

function numberToBytes32(num) {
  var bn = _ethers.utils.bigNumberify(num);
  return _ethers.utils.hexlify(_ethers.utils.padZeros(bn, 32));
}

function bytes32ToNumber(bytes32) {
  return _ethers.utils.bigNumberify(bytes32).toNumber();
}

function stringToBytes32(text) {
  var pad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var data = _ethers.utils.toUtf8Bytes(text);
  if (data.length > 32) {
    throw new Error('too long');
  }
  if (pad) data = _ethers.utils.padZeros(data, 32);
  return _ethers.utils.hexlify(data);
}